/**
 * Formatea un número como moneda
 * @param {number} value - Valor a formatear
 * @returns {string} Valor formateado
 */
const formatCurrency = (value) => {
    if (value === null || value === undefined) return '-';
    return new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: 'ARS',
    }).format(value);
};

export {
    formatCurrency
}